import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {

    ProductSeckillWebList({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/ProductSeckill/WebList',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    ProductSeckillIndex({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/ProductSeckill/Index',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/productSeckill.js